import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  Autocomplete,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GridViewIcon from "@mui/icons-material/GridView";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
//import AddIcon from '@mui/icons-material/Add';
//import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
//import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

const buttonStyle = {
  background: "#f8f9fa",
  border: "3px solid #b0bec5",
  color: "black",
  fontSize: "0.850rem",
  "&:hover": { background: "#eceff1" },
  fontFamily: "Inter, sans-serif",
};
const sectionStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginBottom: 2,
  boxShadow: "0px 4px 8px rgba(0, 0, 1, 0.1)",
  fontFamily: "Inter, sans-serif",
};

const inputStyle = {
  "& .MuiInputBase-root": {
    height: "35px",
    borderRadius: "0",
    fontFamily: "Inter, sans-serif",
  },
};

export default function LandingPageMoodBoard() {
  const [loading, setLoading] = useState(false);
  const [moodboardData, setMoodboardData] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [collectionOptions, setCollectionOptions] = useState([]);

  const handleMoodboardSubmit = async (index) => {
    let item = moodboardData[index];
    let moodboardReqData = {
      id: item.id ? item.id : "",
      moodboard_image: item.moodboard_image ? item.moodboard_image : "",
      linked_url: item.linked_url ? item.linked_url : "",
    };

    let moodboardResData = await postData(
      "/api/theme/landing_moodboard",
      moodboardReqData
    );

    if (moodboardResData["data"]["code"] !== 200) {
      alert("Moodboard data saved successfully");
      setLoading(false);
      return true;
    } else {
      alert("Error saving moodboard data");
      setLoading(false);
    }
    return false;
  };

  useEffect(() => {
    async function fetchData() {
      let resData = await getData("/api/theme/landing_moodboard");
      console.log(resData);
      let banners_data = resData["data"]["mood_boards"];
      if (banners_data) {
        console.log(banners_data);
        if (banners_data) {
          setMoodboardData(banners_data);
        }
      } else {
        console.error("Error fetching moodboard data:", resData.message);
      }

      let collectionResData = await getData("/api/product/product-collection");
      console.log(collectionResData);
      let collections_data = collectionResData["data"]["collection_data"];
      if (collections_data) {
        const formattedCollections = collections_data.map((collection) => ({
          label: collection.collection || "",
          value: collection.id || "",
          link_page: collection.link_page || "",
        }));
        setCollectionOptions(formattedCollections);
      } else {
        console.error("Error fetching collection data:",collectionResData.message);
      }

      setLoading(false);
    }

    fetchData();
  }, []);

  const handleImageUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        moodboardData[index].moodboard_image = reader.result;
        setSelectedFile(file);
      };
      reader.readAsDataURL(file);
    }
  };

  /* const addMoodboard = () => {
        const newMoodboard = { id: null, moodboard_image: '', linked_url: '' }; 
        setMoodboardData([...moodboardData, newMoodboard]); 
    };

    const deleteMoodboard = (index) => {
        const updatedMoodboard = moodboardData.filter((_, i) => i !== index);
        setMoodboardData(updatedMoodboard);
    }; */

  return (
    <Accordion sx={sectionStyle}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton color="" component="icon">
            <GridViewIcon />
          </IconButton>
          <Typography variant="h7">Moodboard</Typography>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <>
            {moodboardData.map((item, index) => (
              <Box
                key={item.id}
                sx={{
                  padding: 4,
                  pt: 0,
                  pb: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  marginBottom: 2,
                  borderRadius: 1,
                  position: "relative",
                }}
              >
                {/*<IconButton sx={{ color: 'red', position: 'absolute', top: 8, right: 8 }} onClick={() => deleteMoodboard(index)}>
                                    <DeleteOutlinedIcon />
                                </IconButton>*/}
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography key={index} sx={{ mt: 1 }}>
                    <figure>
                      <img
                        src={item.moodboard_image || previewImage}
                        alt="Moodboard"
                        style={{
                          width: "100%",
                          maxWidth: "400px",
                          height: "auto",
                          border: "1px solid #ccc",
                          marginBottom: 2,
                        }}
                      />
                      <figcaption style={{ fontSize: 14, fontFamily: "Inter", fontWeight: 500 }}>W 1000px / H 800px</figcaption>
                    </figure>
                  </Typography>
                  <IconButton sx={{ color: "black" }} component="label">
                    <FileUploadOutlinedIcon />
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(e) => handleImageUpload(e, index)}
                    />
                  </IconButton>
                </div>
                <Box sx={{ display: "flex-col", alignItems: "center" }}>
                  <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14,  }}>
                    Link collection page
                  </Typography>
                  <Autocomplete
                    options={[
                      { label: "None", value: "none", link_page: "" },
                      ...collectionOptions,
                    ]}
                    getOptionLabel={(option) => option.label || ""}
                    value={
                      collectionOptions.find(
                        (option) => option.value === item.collection
                      ) || { label: "None", value: "none", link_page: "" }
                    }
                    onChange={(event, newValue) => {
                      const updatedMoodboard = [...moodboardData];
                      if (newValue?.value === "none") {
                        updatedMoodboard[index].collection = ""; // Clear the collection when "None" is selected
                        updatedMoodboard[index].linked_url = ""; // Clear the URL
                        updatedMoodboard[index].isEditable = true; // Enable the text field
                      } else {
                        updatedMoodboard[index].collection =
                          newValue?.value || "";
                        updatedMoodboard[index].linked_url =
                          newValue?.link_page || ""; // Update the URL to the selected collection's link_page
                        updatedMoodboard[index].isEditable = true; // Disable the text field
                      }
                      setMoodboardData(updatedMoodboard);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}              
                        fullWidth
                        sx={{
                          ...inputStyle,
                          width: { xs: "100%", sm: "100%", md: "800px" },
                          marginBottom: 2,
                          mr: 15.5,
                        }}
                      />
                    )}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex-col",
                    alignItems: "center",
                    gap: 2,
                    marginBottom: 1,
                  }}
                >
                  <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14 }}>
                    Url to link collection page
                  </Typography>
                  <TextField
                    fullWidth                    
                    placeholder="URL"
                    variant="outlined"                    
                    sx={{
                      ...inputStyle,
                      width: { xs: "100%", sm: "100%", md: "800px" },
                      marginBottom: 2,
                    }}
                    value={item.linked_url}                    
                    onChange={(e) => {
                      const updatedMoodboard = [...moodboardData];
                      updatedMoodboard[index].linked_url = e.target.value;
                      setMoodboardData(updatedMoodboard);
                    }}
                    disabled={!item.isEditable}
                  />
                  <Button
                    variant="contained"
                    onClick={() => handleMoodboardSubmit(index)}
                    sx={{ ...buttonStyle, mb: 0, mt: 0, ml: 1 }}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            ))}
            {/*<IconButton variant="contained" onClick={addMoodboard} sx={{ ...buttonStyle }}>
                            <AddIcon />
                        </IconButton>*/}
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
